import React, { lazy, Suspense, useEffect, useState } from 'react';
import Loading from '../Component/Loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faPersonCirclePlus } from '@fortawesome/free-solid-svg-icons';
import SEOHelmet from '../Component/SEOHelmet';
import Step from '../Component/Home/4step';

const Header = lazy(() => import('../Component/Header'));
const About = lazy(() => import('../Component/Home/About'));
const Footer = lazy(() => import('../Component/Footer'));
const Culture = lazy(() => import('../Component/Home/Culture'));

const AboutUs = () => {

    const [isScrollTopVisible, setIsScrollTopVisible] = useState(false);
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const [data, setData] = useState(null);

    const handleClick = () => {
        window.location.href = '/hiring';
    };

    useEffect(() => {
        const storedData = sessionStorage.getItem('hiringStatus');
        if (storedData) {
            setData(JSON.parse(storedData)); // Parse the JSON string
        }
    }, []);


    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 200) {
                setIsScrollTopVisible(true);
            } else {
                setIsScrollTopVisible(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            <SEOHelmet
                title="About Us | Plexus Technology"
                description="Learn more about our innovative IT solutions, software development, and IT consulting services."
                keywords="Tech Experts , Innovative Solutions , Tech Team , Business Solutions , Work Culture , Employee Development , Career Growth , Tech Talent , Plexus Mission , Future Technology , Business Transformation , Global IT Services , About Plexus Technology , Tech Company Overview , Technology Experts at Plexus , Innovative Technology Solutions , IT Solutions Provider , Plexus Technology Team , Tech Solutions for Businesses , Life at Plexus Technology , Employee Culture at Plexus , Work at Plexus Technology , Innovative Work Culture , Career Growth at Plexus , Employee Development Programs , Employee Success at Plexus , Tech Talent at Plexus , Plexus Technology Mission , Future of Technology , Shaping the Future with Technology , Transforming Businesses through Technology , Global IT Services Leader"
                ogTitle="About Us | Plexus Technology"
                ogDescription="Discover how Plexus Technology delivers top-notch IT services to businesses globally."
                ogImage="https://plexus-technology.in/static/media/logo.589291ad7a3760919228.png"
                twitterCard="summary_large_image"
            />

            <Suspense fallback={<Loading />}>
                <Header />
                <About />
                <Step />
                <Footer />
            </Suspense>

            {data === "true" && (
                <div className="fixed-button">
                    <button className='animation' style={{ fontSize: "18px" }} onClick={handleClick}>
                        <FontAwesomeIcon icon={faPersonCirclePlus} className="fs-5 pe-2" />
                        We're Hiring
                    </button>
                </div>
            )}

            {isScrollTopVisible && (
                <p className='fixed-top-btn cursor' onClick={scrollToTop}>
                    <FontAwesomeIcon icon={faArrowUp} className='px-2' />
                </p>
            )}
        </>
    );
};

export default AboutUs;